/**
 * Resolves a wallet / navigation payload to the matching row in trading assets
 * (same rules as digital wallet buy/sell deep links).
 */
export interface TradingAssetRef {
  assetId?: string;
  _id?: string;
  symbol?: string;
  asset?: string;
}

export function findMatchingTradingAsset<T extends TradingAssetRef>(
  incoming: TradingAssetRef | null | undefined,
  tradingAssets: T[] | null | undefined
): T | null {
  if (!incoming || !tradingAssets?.length) {
    return null;
  }
  const symbol =
    incoming.symbol?.toUpperCase() ||
    (incoming.asset && String(incoming.asset).toUpperCase());
  const assetId = incoming.assetId || incoming._id;
  return (
    tradingAssets.find(
      (a) =>
        a.assetId === assetId ||
        a._id === assetId ||
        (a.symbol && a.symbol.toUpperCase() === symbol) ||
        (a.asset && String(a.asset).toUpperCase() === symbol)
    ) ?? null
  );
}
